// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const Service = {};

Service.getAmortisasi = function (payload) {
  return lossClient({    
    url: `/ApkLoanKKBFinancial1/regular-interest-amortization`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

Service.getInfoKredit = function (payload) {
  return lossClient({    
    url: `/ApkLoanKKBFinancial1/interestamount`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

Service.getHitungDariAngsuran = function (payload) {
  return lossClient({    
    url: `/ApkLoanKKBFinancial1/frominstallment`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

export default Service;